import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            // title: '首页',
            tab:0,
          }
        }, {
          path: '/products',
          name: 'Products',
          component: resolve => require(['@/view/Products'], resolve),
          meta: {
            // title: '软件产品',
            tab:1,
          }
        },
        {
          path: '/productsdetail',
          name: 'productsdetail',
          component: resolve => require(['@/view/ProductsDetail'], resolve),
          meta: {
            // title: '软件产品丨智能小镇管理系统',
            tab:1,
          }
        },
        {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            // title: '相关服务',
            tab:2,
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            // title: '新闻动态',
            tab:5,
          }
        }, {
          path: '/newInfo',
          name: 'newInfo',
          component: resolve => require(['@/view/newInfo'], resolve),
          meta: {
            title: '新闻详情',
            tab:5,
          }
        },{
          path: '/searchResult',
          name: 'searchResult',
          component: resolve => require(['@/view/searchResult'], resolve),
          meta: {
            // title: '搜索结果'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            // title: '公司介绍',
            tab:4,
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            // title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            // title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          meta: {
            // title: '相关服务',
            tab:2,
          }
        },
        {
          path: '/serviceDetail_old',
          name: 'serviceDetail_old',
          component: resolve => require(['@/view/ServiceDetail_old'], resolve),
          meta: {
            // title: '相关服务',
            tab:2,
          }
        }, //websitePortal
        {
          path: '/websitePortal',
          name: 'websitePortal',
          component: resolve => require(['@/view/websitePortal'], resolve),
          meta: {
            // title: '相关服务',
            tab:7,
          }
        },
        {
          path: '/concatme',
          name: 'concatme',
          component: resolve => require(['@/view/concatme'], resolve),
          meta: {
            // title: '联系我们'
          }
        },
        {
          path: '/case',
          name: 'case',
          component: resolve => require(['@/view/case'], resolve),
          meta: {
            // title: '案列',
            tab:3
          }
        },
        {
          path: '/casedetail',
          name: 'casedetail',
          component: resolve => require(['@/view/caseDetail'], resolve),
          meta: {
            // title: '案列详情',
            tab:3
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js